import React from 'react'
import './index.css';

function StatusButtons(){
    return <div class="status">
       <a class="active">DEL</a>
        <a>DEX</a>
        <a>OOD</a>
        <a>INT</a>
        <a>NFI</a>
     </div>;
}

export default StatusButtons;